import React from 'react';
//import css from './css.less';

import ItemWrapper from '@/src/components/Layouts/Item/Item';

const OverwriteItemWrapper = (props) => {
  const { children, ...rest } = props;
  return (
    <ItemWrapper size='small' {...rest}>
      {children}
    </ItemWrapper>
  );
};
export default OverwriteItemWrapper;
